import React from 'react';
import { NewMessageCancelIcon, NewMessagePlusIcon, NewGroupMessageIcon, NewMessageIcon, GroupBrodcastDropDownIconMobile } from '../../icon';
import * as selector from "../../selectors/selectors";
import { useSelector } from 'react-redux';
import { PlanMetrics } from '../../models/plan-metrics.model';
import { UserPlanTracker } from '../../models/plan-metrics.model';
interface Props {
	OnClickNewMessage: () => void;
	OnClickNewGroupMessage: () => void;
	OnClose: () => void;
	OnClickNewCampaignMessage: () => void;
}

export const NewMessageIconsComponent = (props: Props) => {
	const PlanMetrics: PlanMetrics = useSelector(selector.planMetrics);
	const IsNewOrgFlow: boolean = useSelector(selector.isNewOrgFlow);
	const userPlanTracker: UserPlanTracker = useSelector(selector.userPlanTracker)

	const [open, setOpen] = React.useState<boolean>(false);

	const handleToggle = () => {
		setOpen(!open);
		if (open)
			props.OnClose()
	};

	return (
		<div className="send-message-icon-container">
			<span className='send-message-main d-flex align-center justify-center' onClick={handleToggle}>{open ? <NewMessageCancelIcon style={{ position: "fixed" }} /> : <NewMessagePlusIcon style={{ position: "fixed" }} />}</span>
			{open && <div className="send-message-buttons">
				{(IsNewOrgFlow ? userPlanTracker?.HasGroupChat : PlanMetrics.HasAccessToGroupChat) && <span className='d-flex align-center justify-center'><NewGroupMessageIcon style={{ position: "fixed" }} onClick={props.OnClickNewGroupMessage} /></span>}
				{/* <span className='d-flex align-center justify-center'><GroupBrodcastDropDownIconMobile style={{ position: "fixed" }} onClick={props.OnClickNewCampaignMessage} /></span> */}
				<span className='d-flex align-center justify-center'><NewMessageIcon style={{ position: "fixed" }} onClick={props.OnClickNewMessage} /></span>
			</div>}
		</div>)
};